import React from 'react';
import { cn } from '@utils/cn';

interface FormCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}

export const FormCard: React.FC<FormCardProps> = ({
  title,
  description,
  children,
  className,
  icon,
}) => {
  return (
    <div className={cn("bg-white rounded-lg border border-gray-200 shadow-sm", className)}>
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-start space-x-3">
          {icon && (
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-ncaa-primary text-white rounded-lg flex items-center justify-center">
                {icon}
              </div>
            </div>
          )}
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
            {description && (
              <p className="text-sm text-gray-500 mt-1">{description}</p>
            )}
          </div>
        </div>
      </div>
      <div className="px-6 py-6">
        {children}
      </div>
    </div>
  );
};